import { RECYCLING_PRODUCT_TYPES } from './tbbRegistration';
import TbbPurple from '../images/TBB_purple.png';
import TechBackBox from '../images/tech_tbb_v2.png';
import VirtualBox from '../images/Virtual_TechTBB.png';
import { QUANTITY_TYPES } from '../config/config';
import { SUBSCRIPTION_PAYMENT_TYPES } from './subscriptions';
import { validateShipping } from './service';
import { VALIDATE_SHIPPING_TYPES } from '../config/service';
import { CART_ERROR, getGenericError } from './errors';
import { getUSStates } from './locations';

export const MAX_VALUE_TEXT_ID = ':MAX_VALUE_TEXT:';
export const MAX_VALUE_PROP_TEXT_ID = ':MAX_VALUE_PROP_TEXT:';
const MEMBERSHIP_OFFERED_ITEMS = {
  [RECYCLING_PRODUCT_TYPES.TEXTIL]: {
    id: RECYCLING_PRODUCT_TYPES.TEXTIL,
    title: 'Take Back Bag',
    info: 'For Clothes',
    infoLabels: [
      'Each bag holds up to 15 lbs',
      'Earn 30 TrashieCash each bag',
    ],
    image: TbbPurple,
    imageStyles: {
      maxWidth: '125%',
    },
    multiplier: 3,
    maxValue: 6,
    quantityLabel: { [QUANTITY_TYPES.SINGULAR]: 'Take Back Bag', [QUANTITY_TYPES.PLURAL]: 'Take Back Bags' },
    itemLabels: { [QUANTITY_TYPES.SINGULAR]: 'Bag', [QUANTITY_TYPES.PLURAL]: 'Bags' },
    maxValueText: `${MAX_VALUE_TEXT_ID} ${MAX_VALUE_PROP_TEXT_ID} max per order`,
  },
  [RECYCLING_PRODUCT_TYPES.TECH]: {
    id: RECYCLING_PRODUCT_TYPES.TECH,
    title: 'Tech Box',
    info: 'For Laptops, Phones & Cords',
    infoLabels: [
      'Each box holds up to 10 lbs',
      'Earn 40 TrashieCash each box',
    ],
    image: TechBackBox,
    multiplier: 1,
    maxValue: 2,
    quantityLabel: { [QUANTITY_TYPES.SINGULAR]: 'Take Back Tech Box', [QUANTITY_TYPES.PLURAL]: 'Take Back Tech Boxes' },
    itemLabels: { [QUANTITY_TYPES.SINGULAR]: 'Box', [QUANTITY_TYPES.PLURAL]: 'Boxes' },
    maxValueText: `${MAX_VALUE_TEXT_ID} ${MAX_VALUE_PROP_TEXT_ID} max per order`,
  },
  [RECYCLING_PRODUCT_TYPES.VIRTUAL]: {
    id: RECYCLING_PRODUCT_TYPES.VIRTUAL,
    title: 'Tech Box',
    info: 'For Laptops, Phones & Cords',
    infoLabels: [
      'Each box holds up to 10 lbs',
      'Earn 40 TrashieCash each box',
    ],
    descriptionItems: ['Use your own box', 'Digital labels emailed to you'],
    image: VirtualBox,
    multiplier: 1,
    maxValue: 2,
    quantityLabel: { [QUANTITY_TYPES.SINGULAR]: 'Tech Box (digital label delivery)', [QUANTITY_TYPES.PLURAL]: 'Tech Boxes (digital label delivery)' },
    itemLabels: { [QUANTITY_TYPES.SINGULAR]: 'Box', [QUANTITY_TYPES.PLURAL]: 'Boxes' },
    maxValueText: `${MAX_VALUE_TEXT_ID} ${MAX_VALUE_PROP_TEXT_ID} max per order`,
  },
};

export const MEMBERSHIP_DEFAULT_ORDER_ITEMS = {
  [RECYCLING_PRODUCT_TYPES.TEXTIL]: 3,
  [RECYCLING_PRODUCT_TYPES.TECH]: 1,
  [RECYCLING_PRODUCT_TYPES.VIRTUAL]: 1,
};

/** Quantities for Mega Kit one-time checkout (must match payment flow). */
export const MEGA_KIT_MEMBERSHIP_ORDER_ITEMS = {
  [RECYCLING_PRODUCT_TYPES.TEXTIL]: 4,
  [RECYCLING_PRODUCT_TYPES.TECH]: 1,
  [RECYCLING_PRODUCT_TYPES.VIRTUAL]: 0,
};

export const getFilteredMembershipItems = (selectedWayToBuy) => {
  if (selectedWayToBuy === SUBSCRIPTION_PAYMENT_TYPES.ONE_TIME) {
    return Object.values(MEMBERSHIP_OFFERED_ITEMS).filter(
      (item) => item.id !== RECYCLING_PRODUCT_TYPES.VIRTUAL,
    );
  }

  return Object.values(MEMBERSHIP_OFFERED_ITEMS).filter(
    (item) => item.id !== RECYCLING_PRODUCT_TYPES.TECH,
  );
};

export const getSelectionTotalDisplay = (filteredSelectedItems, selectedAddress, selectedItems) => {
  const totalItems = Object.values(filteredSelectedItems).reduce((acc, count) => acc + count, 0);

  if (!selectedAddress) {
    return 'Select a delivery address';
  }

  if (totalItems === 0) {
    return 'Select Your Products';
  }

  const parts = [];
  Object.values(MEMBERSHIP_OFFERED_ITEMS).forEach((item) => {
    if (filteredSelectedItems[item.id] > 0) {
      parts.push(`${selectedItems[item.id]} ${selectedItems[item.id] > 1 ? item.itemLabels[QUANTITY_TYPES.PLURAL] : item.itemLabels[QUANTITY_TYPES.SINGULAR]}`);
    }
  });

  return `Order ${parts.join(' + ')}`;
};

export const validateShipment = async (
  selectedItems,
  shippingAddress,
  type = VALIDATE_SHIPPING_TYPES.MEMBERSHIP_ORDER,
) => {
  const {
    data,
    error,
  } = await validateShipping({
    type,
    products: selectedItems,
    shippingAddress,
  });

  let isValid = true;
  let message = null;
  let shippingPrice = '0.0';

  if (error?.code === CART_ERROR) {
    isValid = false;
    message = error.message || getGenericError();
  } else if (error?.code) {
    isValid = false;
    message = getGenericError();
  } else if (!data?.shippingRates || data?.shippingRates?.length === 0) {
    isValid = false;
    let stateNames = null;
    const USStates = getUSStates();
    stateNames = USStates.find(state => state.code === shippingAddress.provinceCode)?.name ||
      shippingAddress.provinceCode;

    if (
      data?.excludedStates &&
      data?.excludedStates.length > 0 &&
      data?.excludedStates.includes(shippingAddress.provinceCode)
    ) {
      stateNames = data?.excludedStates.map(
        excludedState => USStates.find(state => state.code === excludedState)?.name ||
        excludedState,
      ).join(', ');
    }

    message = `We cannot ship to ${stateNames} or non U.S. territories.`;
  } else {
    shippingPrice = data?.shippingRates?.[0]?.priceV2?.amount || data?.shippingRates[0]?.price;
  }

  return {
    isValid,
    message,
    shippingPrice,
  };
};

export default MEMBERSHIP_OFFERED_ITEMS;
